import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-dram', 'CurrencyDram', [["path",{"d":"M4 10a6 6 0 1 1 12 0v10"}],["path",{"d":"M12 16h8"}],["path",{"d":"M12 12h8"}]]);